var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutoutTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 21,
    viewBox: "0 0 42 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C9.40202 21 0 11.598 0 0H42C42 11.598 32.598 21 21 21Z",
    fill: "#E6E7E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutoutTop);
export default __webpack_public_path__ + "static/media/CutoutTop.557fa27114e98bf1d51be54bdf24aa64.svg";
export { ForwardRef as ReactComponent };